import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { HomeComponent } from './home/home.component';
import { GenerateDocComponent } from './generate-doc/generate-doc.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
	{ path: 'configure/:sku', component: ConfiguratorComponent },
    { path: 'generate', component: GenerateDocComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
